import React from 'react';
import { Icon } from '@instinet-analytics/semantic-ui-components';
import { Tooltip } from '@instinet-analytics/core-lib';

export default function zeroQuantityRenderer() {
    return (
        <div className="zero-quantity-cell">
            <Tooltip text="Update the quantity to a non-zero value">
                <div className="info-icon">
                    <Icon name="info" />
                </div>
            </Tooltip>
        </div>
    );
}
